import { render, staticRenderFns } from "./GalleryPage.vue?vue&type=template&id=47058dbf&"
import script from "./GalleryPage.vue?vue&type=script&lang=ts&"
export * from "./GalleryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports